import React from "react";
import Link from "next/link";
import styles from "./booking.module.scss";

export const UniPageBookingDemo = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.heading_wrapper}>
            <h3 className={styles.title}>
              Discover Firsthand How You Can Connect with Your Best-Fit
              Prospects
            </h3>
            <div className={styles.button_wrapper}>
              <Link legacyBehavior href="/university/booking">
                <a className={`btn btn-white btn-md`}>Book for Demo</a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniPageBookingDemo;
